import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ApiContext from './contexts/apiContext';
import UserContext from './contexts/userContext';
import { getAuthUser } from './api';
import UserDetail from './components/UserDetail';
import UserSearch from './components/UserSearch';
import LoggedOut from './components/LoggedOut';
import Forbidden from './components/Forbidden';
var App = function (_a) {
    var apiBaseUrl = _a.apiBaseUrl;
    var _b = useState(), user = _b[0], setUser = _b[1];
    var isLoggedOut = window.location.pathname === '/logged-out';
    useEffect(function () {
        if (isLoggedOut) {
            return;
        }
        getAuthUser(apiBaseUrl)
            .then(setUser)
            .catch(function () { return window.location.assign("".concat(apiBaseUrl, "/auth")); });
    }, []);
    if (!user && !isLoggedOut) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(CssBaseline, {}), _jsx(ApiContext.Provider, { value: { apiBaseUrl: apiBaseUrl }, children: _jsx(UserContext.Provider, { value: { user: user }, children: _jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(UserSearch, {}) }), _jsx(Route, { path: "/users/:id", element: _jsx(UserDetail, {}) }), _jsx(Route, { path: "/logged-out", element: _jsx(LoggedOut, {}) }), _jsx(Route, { path: "/forbidden", element: _jsx(Forbidden, {}) })] }) }) }) })] }));
};
export default App;
